class BlockChronology {
	constructor() {

		const chronologyBlock = document.querySelector('.block-chronology');

		if( !chronologyBlock )
			return;

		const accentColor = getComputedStyle(document.body).getPropertyValue('--color-orange');

		const chronologyTitle = document.querySelectorAll('.chronology-title');
		ScrollTrigger.create({
			trigger: chronologyTitle,
			pin: chronologyTitle,
			start: "top 5%",
			endTrigger : '.block-chronology',
			end: "bottom bottom",
			pinSpacing: false
		});

		const chronologyItems = document.querySelectorAll(".chronology-item");
		chronologyItems.forEach(item => {
			gsap.to( item, {
				opacity: 1,
				scrollTrigger: {
					trigger: item,
					start: "top 90%",
					end: "top 60%",
					scrub: 0.5
				}
			});
			//
			// gsap.to( item, {
			// 	opacity: 0,
			// 	scrollTrigger: {
			// 		trigger: item,
			// 		start: "top 30%",
			// 		end: "top top",
			// 		scrub: 0.5
			// 	}
			// });

			let title = item.querySelector('.inner');
			const initialColor = getComputedStyle(title).color;

			gsap.to(title, {
				color: accentColor,
				scrollTrigger: {
					trigger: item,
					start: "top 60%",
					end : "center 50%",
					scrub: 0.5,
				}
			});

			gsap.to(title, {
				color: initialColor,
				immediateRender: false,
				scrollTrigger: {
					trigger: item,
					start: "center 50%",
					end : "bottom 30%",
					scrub: 0.5
				}
			});

		});
	}
}
